export function storeBulk(data, filters)
{
	filters = filters || {};

    return axios.post(
        route('api.manage.companies.contacts.store') + '?include=timelineEvent,documents',
        data,
        {params: {...filters}}
    )
    	.then(response => response.data);
}

export function update(id, data)
{
    return axios.patch(route('api.manage.contacts.update', {contactId: id}) + '?include=timelineEvent,documents', data)
        .then(response => response.data);
}

export function destroy(id)
{
    return axios.delete(route('api.manage.contacts.update', { contactId: id }))
        .then(response => response.data);
}
